import { render } from "./BudgetTemplateUpdate.vue?vue&type=template&id=4baec9bd&scoped=true"
import script from "./BudgetTemplateUpdate.vue?vue&type=script&lang=js"
export * from "./BudgetTemplateUpdate.vue?vue&type=script&lang=js"

import "./BudgetTemplateUpdate.vue?vue&type=style&index=0&id=4baec9bd&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4baec9bd"]])

export default __exports__